import React from 'react';
import { Link } from 'wouter';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight, Sparkles } from 'lucide-react';
import bpc157PreviewImage from '@/assets/images/bpc157-preview Large.jpeg';

export default function PremiumBanner() {
  return (
    <Card className="mt-8 mb-12 border-0 bg-gradient-to-r from-indigo-50 to-blue-50 overflow-hidden">
      <CardContent className="p-0">
        <div className="p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-3">
              <Sparkles className="h-5 w-5 text-indigo-500" />
              <span className="font-semibold text-indigo-600">Premium Content</span>
            </div>
            <h3 className="text-2xl font-bold mb-2">Next Generation Peptide Guide</h3>
            <p className="text-gray-600 mb-4 max-w-xl">
              Access our comprehensive, science-based peptide resource with detailed mechanisms of action, 
              signaling pathways, clinical evidence, and practical application guides.
            </p>
            <Button 
              onClick={() => window.location.href = '/premium'}
              className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700">
              Explore Premium Content <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
          <div className="hidden md:block relative overflow-hidden rounded-lg shadow-xl border border-gray-200">
            <div className="relative overflow-hidden w-60 h-40">
              <img 
                src={bpc157PreviewImage}
                alt="BPC-157 Premium Content Preview" 
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                <div className="text-white text-sm font-medium">BPC-157 Protocol</div>
                <div className="text-white/80 text-xs">Interactive Premium Content</div>
              </div>
              <div className="absolute top-2 right-2 bg-indigo-600 text-white text-xs py-1 px-2 rounded-full">
                Exclusive
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}